import { Paper } from '@mui/material';
import type { ActionItem, Newsletter } from '@/types';
import { buildNewsletterBodyHtml, DOCUMENT_STYLES } from '@/services/exportService';

/** Renders a full newsletter issue as styled HTML, shared by the Preview page and print output. */
export default function NewsletterRenderer({
  newsletter,
  actionItems,
}: {
  newsletter: Newsletter;
  actionItems: ActionItem[];
}) {
  return (
    <Paper variant="outlined" id="newsletter-print-root" sx={{ p: { xs: 3, md: 5 }, maxWidth: 820, mx: 'auto' }}>
      <style>{DOCUMENT_STYLES.replace(/body \{[^}]*\}/, '')}</style>
      <div dangerouslySetInnerHTML={{ __html: buildNewsletterBodyHtml(newsletter, actionItems) }} />
    </Paper>
  );
}
